/** leads/FlowHelp.tsx — 데이터 흐름 설명 (ℹ️ 버튼 → 모달, 나중에 안 까먹게) */
import React, { useState } from 'react';

const S: React.CSSProperties = { fontSize: 12.5, lineHeight: 1.85, color: '#374151' };

export default function FlowHelp() {
  const [open, setOpen] = useState(false);
  if (!open) {
    return <button className="ld-btn" style={{ padding: '6px 10px', fontSize: 12 }} title="이 모듈의 데이터 흐름 설명" onClick={() => setOpen(true)}>ℹ️ 데이터 흐름</button>;
  }
  return (
    <div className="ld-modal-bg" onClick={() => setOpen(false)}>
      <div className="ld-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ld-modal-h">데이터 흐름 — 벤처투자 경정청구<button className="ld-btn" onClick={() => setOpen(false)}>닫기</button></div>
        <div className="ld-modal-b" style={S}>
          <b>① 벤처기업 (모수)</b><br />
          중기부 명단 CSV를 연도별(2019~2024)로 업로드 — 순서 무관, 같은 회사·같은 기간은 자동 병합(추가만 — 삭제·덮어쓰기 없음), 새 기간은 행 추가. 기존 값과 다른 값이 오면 <b>덮지 않고 특이사항 모달로 물어봅니다.</b>
          파일에 법인등록번호가 있으면 확정 저장, 없으면 스캔이 이름+지역 교차검증으로 찾아 <b style={{ color: '#B45309' }}>(추정)</b> 표시.<br /><br />
          <b>② 조회 버튼 3개 (벤처기업 탭)</b> — [법인번호만 조회] 개요 API로 번호 선확보(핵심어 검색+지역+대표자 성 검증) / [증자이력 조회] 번호 보유 업체만 재무 조회 / [법인번호+증자이력] 일괄.<br />
          범위(현재 필터 또는 체크 선택) 안의 회사를 금융위 API로: 법인등록번호 확보 → 적재 규칙: <b>2021년 이후 증자(설립 출자 포함) 전부 → 증자 업체 탭</b>(유효기간 무관), 그중 <u>§16 게이트(투자 후 2년 내 유효기간 겹침) 통과분만 → 경정청구 대상 리드 자동</u>.
          결과는 증자 업체 탭에 적재되고, 사업자번호까지 확보된 건은 <b>경정청구 대상에 리드 자동 생성</b>(대표자·전화 보완).
          🌙 야간 자동(우측 상단)을 켜면 매일 새벽 2시 반복 — 쿼터(일 9,000콜) 도달 시 자동 중단·다음날 이어받기, 결과는 배너에 기록.<br /><br />
          <b>③ 증자 업체 (증자 원장 — 기록 + 검토 대기실)</b><br />
          스캔 적재분 + 외부 증자 명단 수동 업로드. [벤처 대조 실행]으로 명단과 교차 확인, 사업자번호 없는 건은 확보 후 [리드 확정].<br /><br />
          <b>④ 경정청구 대상 (최종 영업 DB)</b><br />
          자동 유입(스캔·대조) + 후보 [리드 승격] + 직접 등록(단건·엑셀). 중복은 (사업자번호+증자연도) 기준 3중 방어 — 어떤 경로로 겹쳐도 기존 건에 연결.
          [법인번호 자동 조회]는 <u>직접 등록한 리드</u>의 번호를 사업자번호 교차검증으로 확보(확정) — FP 포털 [재무제표]의 열쇠.<br /><br />
          <b>FP 동선</b>: 배정 → 카톡 포털 → 전화·DM·재무제표 → 결과 보고(성공 시 업무관리 자동 전환 / 반납 시 메모 승계).
        </div>
      </div>
    </div>
  );
}
